import React, { useState } from "react";
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  Image,
  ActivityIndicator,
} from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppImages } from "../../utility/AppImages";
import * as Linking from "expo-linking";
import { toast } from "react-toastify";
import { fetchPaymentCreateSession } from "../../services/profileAPI";
import { useLiveStream } from "../../context/LiveStreamContext";
import { getUserLocationDetails } from "../../common/getLocation";
import { LinearGradient } from "expo-linear-gradient";

const GetTokenPopup = ({
  tokenPackages,
  selectedPackage,
  handlePackageSelect,
  width,
  boxRightMargin,
}) => {
  const deviceSize = useDeviceSize();
  const { currentEventId, loginData } = useLiveStream();
  const [loading, setLoading] = useState(false); // Loading state for the button

  const handlePurchase = async () => {
    if (!selectedPackage) {
      toast.error("Please select a token package to purchase.");
      return;
    }

    setLoading(true); // Set loading to true when the button is clicked

    try {
      const tokensToPurchase = selectedPackage.tokens;
      const price = selectedPackage.price;
      const location = await getUserLocationDetails();
      const countryCode = location?.country_code || "GB"; // Default to UK if location not available
      const sessionData = await fetchPaymentCreateSession(
        loginData?.accessToken,
        tokensToPurchase,
        price,
        currentEventId,
        countryCode,
        "stream"
      );

      console.log("Payment session response:", sessionData);

      if (sessionData.statusCode === 303 && sessionData.body?.url) {
        Linking.openURL(sessionData.body.url);
      } else {
        const errorMsg = sessionData.body?.message || sessionData.message || "Error creating payment session. Please try again.";
        console.error("Payment session failed:", {
          statusCode: sessionData.statusCode,
          body: sessionData.body,
          fullResponse: sessionData
        });
        toast.error(errorMsg);
      }
    } catch (error) {
      console.error("Payment session error:", error);
      toast.error("Payment failed. Please check your network and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <View
      style={{
        backgroundColor: "black",
        marginTop: 6,
      }}
    >
      <View
        style={{
          width: "100%",
          paddingBottom: 16,
          paddingHorizontal: 16,
          backgroundColor: "#111827",
          borderRadius: 10,
          justifyContent: "space-between",
          borderColor: "#374151",
          borderWidth: 1,
        }}
      >
        <View
          style={{
            backgroundColor: "#111827",
            paddingTop: 16,
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_24,
              { marginBottom: 10, color: AppColors.white },
            ]}
          >
            Get Tokens
          </Text>
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={true}
            contentContainerStyle={{
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 10,
              marginBottom: 10,
            }}
          >
            {tokenPackages.map((item: any, index: number) => {
              const isSelected =
                selectedPackage && selectedPackage.tokens === item.tokens;

              // Calculate base tokens and bonus
              const baseTokens = item.tokens > 88 ? item.tokens - 77 : item.tokens;
              const hasBonus = item.tokens > 88;

              return (
                <TouchableOpacity
                  key={index}
                  onPress={() => handlePackageSelect(item)}
                  style={{ position: "relative" }}
                >
                  {/* Badge image at top right */}
                  {hasBonus && (
                    <Image
                      source={AppImages.Ko_Token_Bonus_Badge}
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: 48,
                        height: 16,
                        zIndex: 10,
                        transform: [{ translateX: -8 }, { translateY: 8 }],
                      }}
                      resizeMode="contain"
                    />
                  )}

                  <LinearGradient
                    colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={{
                      flex: 1,
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 14,
                      borderRadius: 10,
                      marginVertical: 5,
                      marginHorizontal: 5,
                      paddingVertical: 18,
                      paddingHorizontal: 10,
                      height: 110,
                      borderWidth: isSelected ? 2.5 : 0.8,
                      borderColor: isSelected
                        ? AppColors.appViolentColor_6D08C3
                        : "rgba(139, 147, 176, 0.10)",
                    }}
                  >
                    {/* Image + Token number + bonus text in row */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        marginTop: hasBonus ? 6 : 0,
                      }}
                    >
                      <Image
                        source={AppImages.Ko_Token}
                        style={{
                          height: 50,
                          width: 50,
                        }}
                      />
                      <View style={{ gap: 4, flex: 1 }}>
                        <Text
                          style={{
                            fontFamily: "Anybody_700Bold",
                            fontSize: 32,
                            fontWeight: "700",
                            lineHeight: 32,
                            color: AppColors.koBrandRed,
                          }}
                          numberOfLines={1}
                        >
                          {item.tokens.toLocaleString()}
                        </Text>
                        {hasBonus && (
                          <Text
                            style={{
                              fontFamily: "Anybody_400Regular",
                              fontSize: 12,
                              fontWeight: "400",
                              lineHeight: 14,
                              color: AppColors.gray_8B93B0,
                            }}
                            numberOfLines={1}
                          >
                            {baseTokens.toLocaleString()} + 77 bonus
                          </Text>
                        )}
                      </View>
                    </View>

                    {/* Price at bottom */}
                    <Text
                      style={{
                        color: "#FFF",
                        textAlign: "center",
                        fontSize: 30,
                        fontWeight: "700",
                        lineHeight: 30,
                      }}
                      numberOfLines={1}
                    >
                      {item.price}
                    </Text>
                  </LinearGradient>
                </TouchableOpacity>
              );
            })}
          </ScrollView>
        </View>
        <View>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_10,
              {
                color: AppColors.koBrandLightGray,
                marginBottom: 8,
              },
            ]}
          >
            By continuing you agree to Token Policy
          </Text>
          <TouchableOpacity
            onPress={handlePurchase}
            disabled={loading || !selectedPackage}
            style={{
              paddingVertical: 12,
              backgroundColor: loading
                ? "#6B7280"
                : !selectedPackage
                ? "#6B7280"
                : "#DC2626",
              borderRadius: 6,
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "center",
              gap: 8,
            }}
          >
            {loading ? (
              <ActivityIndicator size="small" color={AppColors.white} />
            ) : (
              <>
                <Text style={[AppFontStyle.BOLD_ANYBODY_16, { color: AppColors.white }]}>
                  Get
                </Text>
                {selectedPackage && (
                  <Image
                    source={AppImages.Ko_Token}
                    style={{
                      height: 20,
                      width: 20,
                    }}
                    resizeMode="contain"
                  />
                )}
                <Text style={[AppFontStyle.BOLD_ANYBODY_16, { color: AppColors.white }]}>
                  {selectedPackage
                    ? `${selectedPackage.tokens.toLocaleString()} (${
                        selectedPackage.price
                      })`
                    : "Select a package"}
                </Text>
              </>
            )}
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default GetTokenPopup;
